module.exports = __webpack_public_path__ + "img/sync-goods-bai.b6b540c0.svg";